// Auto generated file, do not manually modify!
// com.hotpads.leasing.api.web.v1.waitlist.WaitlistWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  AddToGenericWaitlistWebApiRequestDto,
  AddToWaitlistWebApiRequestDto,
  DeclineToWaitlistRequestDto,
  IsOnWaitlistWebApiResponseDto,
} from '../..';

interface DeleteByStateParams {
  state: string;
}
interface IsOnWaitlistParams {
  propertyId: string;
}

export const WaitlistWebApiHandler_addToGenericWaitlist_Path = '/api/web/v1/waitlist/addToGenericWaitlist';

/**
 * Add to Generic Waitlist
 */
export const WaitlistWebApiHandler_addToGenericWaitlist = (
  postData: AddToGenericWaitlistWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, AddToGenericWaitlistWebApiRequestDto, void>(
    {
      endpoint: WaitlistWebApiHandler_addToGenericWaitlist_Path,
      method: 'POST',
      contextPath: '/leasing',
      postData: postData,
    },
    client,
  );
};

export const WaitlistWebApiHandler_addToWaitlist_Path = '/api/web/v1/waitlist/addToWaitlist';

/**
 * add listing and user Ids to waitlist
 */
export const WaitlistWebApiHandler_addToWaitlist = (postData: AddToWaitlistWebApiRequestDto, client = getClient()) => {
  return httpFrontEndRequest<never, AddToWaitlistWebApiRequestDto, void>(
    {
      endpoint: WaitlistWebApiHandler_addToWaitlist_Path,
      method: 'POST',
      contextPath: '/leasing',
      postData: postData,
    },
    client,
  );
};

export const WaitlistWebApiHandler_declineToWaitlist_Path = '/api/web/v1/waitlist/declineToWaitlist';

/**
 * add decline listing and user Ids to waitlist
 */
export const WaitlistWebApiHandler_declineToWaitlist = (
  postData: DeclineToWaitlistRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, DeclineToWaitlistRequestDto, void>(
    {
      endpoint: WaitlistWebApiHandler_declineToWaitlist_Path,
      method: 'POST',
      contextPath: '/leasing',
      postData: postData,
    },
    client,
  );
};

export const WaitlistWebApiHandler_deleteByState_Path = '/api/web/v1/waitlist/deleteByState';

/**
 * delete waitlist by state
 */
export const WaitlistWebApiHandler_deleteByState = (getParams: DeleteByStateParams, client = getClient()) => {
  return httpFrontEndRequest<DeleteByStateParams, never, void>(
    {
      getParams: getParams,
      endpoint: WaitlistWebApiHandler_deleteByState_Path,
      method: 'POST',
      contextPath: '/leasing',
    },
    client,
  );
};

export const WaitlistWebApiHandler_isOnWaitlist_Path = '/api/web/v1/waitlist/isOnWaitlist';

/**
 * get is listing on waitlist
 */
export const WaitlistWebApiHandler_isOnWaitlist = (getParams: IsOnWaitlistParams, client = getClient()) => {
  return httpFrontEndRequest<IsOnWaitlistParams, never, IsOnWaitlistWebApiResponseDto>(
    {
      getParams: getParams,
      endpoint: WaitlistWebApiHandler_isOnWaitlist_Path,
      method: 'GET',
      contextPath: '/leasing',
    },
    client,
  );
};
